<campus-icon [svgIcon]="iconClass" *ngIf="iconClass"></campus-icon> <ng-content></ng-content>
